import { Component, HostListener } from '@angular/core';
import { DeviceService } from '../services/device-service/device.service';
import { ColDef, GridOptions, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { AG_GRID_PAGE_SIZE_OPTIONS, AG_GRID_DEFAULT_PAGE_SIZE } from '../shared/ag-grid/ag-grid-pagination.util';

import { AgGridAngular } from 'ag-grid-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { get } from 'lodash'; // for copy data cell value
import { CommentCellRendererComponent } from '../comment-cell-renderer/comment-cell-renderer.component';
import { AgGridCopyCellTooltipDirective } from '../shared/ag-grid/ag-grid-copy-cell-tooltip.directive';

@Component({
  selector: 'app-ota-history',
  standalone: true,
  imports: [CommonModule,AgGridAngular,MatFormFieldModule,MatSelectModule,MatSelectModule, MatIconModule,
    CommentCellRendererComponent,
    AgGridCopyCellTooltipDirective,
  ],
  templateUrl: './ota-history.component.html',
  styleUrl: './ota-history.component.scss'
})
export class OtaHistoryComponent {
  rowData: any;
  gridApi: any;
  page: number = 0;
  size: number = 25;
  totalElements: any;
  sortFlag: boolean = false;
  deviceId:any;
  paginationPageSize = AG_GRID_DEFAULT_PAGE_SIZE;
  readonly pageSizeOptions = AG_GRID_PAGE_SIZE_OPTIONS;
  currentPage:any;
  rowHeight = 100;

constructor(private deviceService:DeviceService){}

 defaultColDef: ColDef = {
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    sort: 'desc',
    floatingFilter: false,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Time (UTC)',
      field: 'updateOn',
      // valueGetter: (params) => params.data?.createdOn || 'N/A',
      cellRenderer: (params: any) => {
        const updateOn = params?.data?.updateOn;
        if (updateOn === undefined) {
          return '';
        } else if (updateOn === null || updateOn === '') {
          return 'N/A';
        } else {
          return moment.utc(params?.data?.updateOn).format('YYYY-MM-DD HH:mm:ss');
          //return moment.utc(updateOn).local().format('YYYY-MM-DD HH:mm:ss')
        }
      },
      // cellRenderer: (params: any) => {
      //   if (params?.data?.updateOn) {
      //     // Convert installationDate to a JavaScript Date object
      //     const date = new Date(params.data.updateOn);

      //     // Format the date using Intl.DateTimeFormat
      //     const formattedDate = new Intl.DateTimeFormat('en-US', {
      //       year: '2-digit',
      //       month: '2-digit',
      //       day: '2-digit',
      //       hour: '2-digit',
      //       minute: '2-digit',
      //       hour12: true,
      //       timeZone: 'America/Los_Angeles', // Adjust for PST
      //     }).format(date);

      //     // Add "PST" to the formatted date
      //     return formattedDate.replace(',', '') + ' PST';
      //   }
      //   return 'NA';
      // },
    },
    {
      headerName: 'Event Type',
      field: 'entityName',
      valueGetter: (params) => params.data?.eventType?.category || 'N/A',
    },

    {
      headerName: 'Status',
      field: 'status',
      valueGetter: (params) => params.data?.eventType?.status || 'N/A',
    },
    // {
    //   headerName: 'Comments',
    //   field: 'details',
    //   flex: 1,
    //   cellStyle: { 'white-space': 'normal' , 'word-break': 'break-all', 'overflow': 'visible', 'overflow-wrap': 'break-word'},
    //   wrapText: true,
    //   valueGetter: (params) => params?.data?.details || 'N/A',
    //   tooltipValueGetter: (params) => params?.data?.details
    // },
    {
      headerName: 'Comments',
      field: 'details',
      flex: 1,
      cellRenderer: CommentCellRendererComponent,
      tooltipValueGetter: (params) => params?.data?.details,
      cellStyle: {
        'white-space': 'normal',
        'word-break': 'break-word',
        'overflow-wrap': 'break-word'
      }
    }
  ];
  public gridOptions: GridOptions = {
    enableBrowserTooltips: true,
    tooltipShowDelay: 500,
    tooltipHideDelay: 1000,
    domLayout: 'autoHeight',
    // context: {
    //   componentParent: this  // ✅ Pass this reference
    // },
    suppressRowTransform: true, // Helps with dynamic height
    getRowHeight: (params) => {
      const details = params?.data?.details || '';
      const baseHeight = 130;
      const lineLength = 90;
      const lineHeight = 20;
      const lineCount = Math.ceil(details.length / lineLength);
      return baseHeight + lineCount * lineHeight;
    }

  }
  deviceHistoryPayload = {
    "page": 0,
    "size": 25,
    "filters": [
      {
        "field": "entityId",
        "operator": "eq",
        "value": ""
      },
  //     {
  //       "field": "eventType.id",
  //       "operator": "ne",
  //       "value": "11"
  //     }
  // ,  {
  //       "field": "eventType.id",
  //       "operator": "ne",
  //       "value": "12"
  //     }
    ],
    "sorts": [
      {
        "field": "entityId",
        "direction": "asc"
      }
    ]
  }
  onPaginationChanged(event: PaginationChangedEvent): void {
    this.currentPage = event.api.paginationGetCurrentPage();
    this.deviceHistoryPayload.page=this.currentPage;
}

  sortForAgGrid(sortModel: any) {
    if ( sortModel[0] == undefined ||sortModel[0] == null ||sortModel[0].colId == undefined ||sortModel[0].colId == null) {
      return;
    }
    this.sortFlag = true;
    switch (sortModel[0].colId) {
      case 'entityName': {
        this.deviceHistoryPayload.sorts[0].field = 'eventType.category';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'updateOn': {
        this.deviceHistoryPayload.sorts[0].field = 'updateOn';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'status': {
        this.deviceHistoryPayload.sorts[0].field = 'eventType.status';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'details': {
        this.deviceHistoryPayload.sorts[0].field = 'details';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      default: {
      }
    }
  };

  /* Start Copy Data cell Value function   */
  contextMenu: { visible: boolean; x: number; y: number; value: any } = {
    visible: false,
    x: 0,
    y: 0,
    value: ''
  };
  selectedCellValue: string = '';
  contextMenuVisible: boolean = false;
  contextMenuPosition = { x: 0, y: 0 };

  getNestedProperty(obj: any, path: string): any {
    return get(obj, path, 'N/A'); // 'N/A' if value is undefined
  }


  onCellContextMenu(event: any) {
    event.event.preventDefault(); // Prevent the browser's default context menu

    let cellValue;
    const columnField = event.colDef.field;

    if (columnField === 'updateOn') {
      const updateOn = event?.data?.updateOn;
      if (updateOn === undefined) {
        cellValue = '';
      } else if (updateOn === null || updateOn === '') {
        cellValue = 'N/A';
      } else {
        cellValue = moment.utc(updateOn).format('YYYY-MM-DD HH:mm:ss');
        // issue#2398 start
        // Removed local() to ensure copied value remains in UTC exactly as displayed
        // Description: Copy now uses moment.utc(...).format(...) so clipboard time matches grid's UTC rendering
        // issue#2398 end
      }
    } else if (event.colDef.valueGetter) {
      cellValue = event.colDef.valueGetter({ data: event.data });
    } else {
      cellValue = this.getNestedProperty(event.data, columnField);
    }

    // Set context menu visibility and position
    this.contextMenu = {
      visible: true,
      x: event.event.clientX,
      y: event.event.clientY,
      value: cellValue || 'N/A',
    };
  }


  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied to clipboard:', value);
      this.contextMenu.visible = false;  // Hide context menu after copying
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }


  // Hide context menu on outside click
  @HostListener('document:click')
  onDocumentClick(): void {
    this.contextMenu.visible = false;
  }
  preventDefaultContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }
  /* End Copy Data cell Value function   */

   onGridReady(params: GridReadyEvent) {

      this.deviceId = localStorage.getItem('deviceId');
      this.gridApi = params;
      // this.gridApi.api.sizeColumnsToFit();


      console.log("= ",this.gridApi.api.paginationGoToNextPage)
      const dataSource = {
        getRows: (params: any) => {
          this.sortForAgGrid(params.sortModel);
          this.gridApi.api.setFilterModel(
              this.deviceHistoryPayload.filters[0] = {
                field: 'entityId',
                operator:'eq',
                value: this.deviceId
              }
            )
          this.deviceService
            .getOtaAuditHistory(this.deviceHistoryPayload)
            .subscribe({
              next: (data: any) => {
                if (data.data) {
                  this.rowData = data?.data?.content;
                  console.log('peripherals data :', this.rowData);
                  this.totalElements = data?.data?.totalElements;
                  console.log('totalElements :', this.totalElements);
                  params.successCallback(this.rowData, this.totalElements);
                  const currentPageData = data?.data?.content.reduce((acc:any,item:any)=>{
                    acc[item.id] = item
                    return acc
                  },{} as any);
                  this.deviceService.fetchCurrentPageData = {...this.deviceService.fetchCurrentPageData, ...currentPageData}
                  console.log({NewData:this.deviceService.fetchCurrentPageData})
                }
              },
              error: (error) => {
                console.error('API Error:', error);
                params.failCallback();
              },
            });
        },
      };
      this.gridApi.api.setGridOption('datasource', dataSource);
    }
    // selectEventType(data: any){
    //   console.log("event type ",data.target.value)
    //   if(data.target.value =="All"){
    //     const val = this.deviceHistoryPayload.filters.splice(1, 1);
    //     console.log('val',val)
    //   }else{
    //   this.gridApi.api.setFilterModel(
    //     this.deviceHistoryPayload.filters[1] = {
    //       field: 'eventType.Id',
    //       operator:'eq',
    //       value: data.target.value
    //     }
    //   )}
    //   this.gridApi.api.onFilterChanged();

    // }
}
